export default __webpack_public_path__ + "static/media/pencil.35f899b1.png";